import { Fade, IconButton, Modal, Paper, Tooltip, Typography, Box } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

export default function ImageModalSingle({ imageSrcSingle, setImageSrcSingle, imageSingleDescriptions = ''}) {
    return (
        <Modal
            open={true}
            onClose={() => setImageSrcSingle(null)}
            closeAfterTransition
            slotProps={{
                backdrop: {
                    timeout: 500,
                    sx: { backgroundColor: 'transparent' },
                }
            }}
            className="flex abs-center"
        >
            <Fade in={true}>
                <Paper
                    sx={{
                        width: '90vw',
                        height: '90vh',
                        overflow: 'hidden',
                        position: 'relative',
                        display: 'flex',
                        flexDirection: 'column', // Вертикальная ориентация
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 2, // Добавляем отступы
                    }}
                >
                    <Tooltip title="Закрити">
                        <IconButton
                            sx={{
                                position: 'absolute',
                                right: 10,
                                top: 10,
                                backgroundColor: '#eee',
                                '&:hover': {
                                    backgroundColor: 'red',
                                },
                            }}
                            onClick={() => setImageSrcSingle(null)}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Tooltip>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '70%', // Устанавливаем размер для изображения
                        }}
                    >
                        <img
                            src={imageSrcSingle}
                            alt="Full size image"
                            style={{
                                maxWidth: '100%',
                                maxHeight: '100%',
                                objectFit: 'contain',
                                display: 'block',
                            }}
                        />
                    </Box>
                    <Typography
                        variant="body1"
                        sx={{
                            textAlign: 'center',
                            marginTop: 2, // Отступ сверху
                            color: '#000000', // Серый текст
                            fontSize: '1rem',
                            fontWeight: 'bold',
                            maxWidth: '80%', // Ограничиваем ширину описания
                        }}
                    >
                        {imageSingleDescriptions}
                    </Typography>
                </Paper>
            </Fade>
        </Modal>
    );
}
